import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Countries } from '../../modules/login/countries';
import { Login } from '../../modules/login/login';
import { PlayerService } from '../player/player.service';
import { Store } from '@ngrx/store';
import * as appState from '../../appstates/appState';
import { PlayerLoggedIn } from '../../appstates/loginstates/loginActions';
import { PlayerGetProfile } from '../../appstates/playerstates/playerActions';
import { Observable } from 'rxjs';
import { AllGames } from '../../modules/slotsmodel/allgames';
import { AllGameLunch } from '../../modules/slotsmodel/allgamelunch';
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private _AllGames = 'assets/MrSlottyGames_trophy.json';
  private _Nonce = 'api/player/nonce?address';
  constructor(private httpClient: HttpClient,
    private playerService: PlayerService,
    private store: Store<appState.AppState>
  ) {
    if (sessionStorage.getItem('wsessionBD')) {
      this.onPlayerLoggedIn(true)
    }
  }
  httpOptions() {
    let option = {

      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'siteid': environment.skinId
      })
    }
    return option;
  };
  httpOptionsotp() {
    let option = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })

    }
    return option;
  };

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'siteid': environment.skinId
  });

  onPlayerLoggedIn(value: boolean) {
    this.store.dispatch(new PlayerLoggedIn({ loggedIn: value }));

  }
  onGetPlayerProfile() {
    this.store.dispatch(new PlayerGetProfile());
  }
  verifyAccount(body:any): Observable<any> {
    // return this.http.get(`${environment.appApi.baseUrl}${environment.appApi.vivourl}`, this.playerService.httpOptionsVivo());
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.player.verifyAccount}`,body, this.httpOptions());
  }
  onGenerateCaptchaStart(): Observable<Blob> {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.generateCaptcha}`,
      {}, { headers: this.headers, responseType: 'blob' });
  }
  onLogin(postdata: Object) {
    return this.httpClient.post<Login>(`${environment.api.baseUrl}${environment.api.login}`, postdata, this.httpOptions());
  }
  onSportRemoteLogin(postdata: { operatorId: String; token: String; loginName: String; }) {
    return this.httpClient.post<Login>(`${environment.api.baseUrl}${environment.api.remotelogin}`, postdata, this.httpOptions());
  }
  onLogOut(): Observable<Login> {
    return this.httpClient.post<Login>(`${environment.api.baseUrl}${environment.api.logout}`, {}, this.playerService.httpOptions());
  }
  onRegister(postdata: Object) {
    return this.httpClient.post<Login>(`${environment.api.baseUrl}${environment.api.register}`, postdata, this.httpOptions());
  }
  onGetRegisterCountry() {
    return this.httpClient.post<Countries>(`${environment.api.baseUrl}${environment.api.getCountries}`, {}, this.httpOptions());
  }
  getHitcount(data: { campaignId: any; campaignType: string; languageCode: string; }) {

    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.getHitCountSummary}`, data, this.httpOptions());
  }
  onForgotPassword(postdata: Object) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.fotgotPassword}`, postdata, this.httpOptions());
  }

  onRegisterGenarateOTPStart(postdata: Object) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.generateOTP}`, postdata, this.httpOptions());
  }
  getotp(postdata: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.generateOTP}`, postdata, this.httpOptionsotp());
  }
  getotpverify(postdata: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.validOTP}`, postdata, this.httpOptionsotp());
  }
  onContactUsSendStats(postdata: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.contactus}`, postdata);
  }
  AllGamesData() {
    return this.httpClient.get<AllGames>(this._AllGames);
  }
  mPayGamesToken(postdata: string) {
    return this.httpClient.get<any>(`${postdata}`, {});
  }
  AllGamesLunch(postdata: Object) {
    return this.httpClient.post<AllGameLunch>(`${environment.api.baseUrl}${environment.api.allGamesUrl}`, postdata, this.playerService.httpOptions());
  }
  GetNonce() {
    return this.httpClient.get<any>(this._Nonce)
  }
  WebAuthVerify(postdata: Object) {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.webAuthVerify}`, postdata, this.playerService.httpOptions());
  }
  userdata: any;

  ngOnInit() {

  } 
  userslist(data: any) {

    this.userdata = data;
  }
}
